import React from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import { basicRoutes } from "./routes/basic";
import { proRoutes } from "./routes/pro";

// Global error catcher for unexpected runtime issues
window.onerror = function (message, source, lineno, colno, error) {
  console.error("Global JS Error:", {
    type: "window.onerror",
    message,
    source,
    lineno,
    colno,
    stack: error?.stack || null,
  });

  window.location.href = "/embedded/jumpstart/error";
};

window.onunhandledrejection = function (event) {
  const reason = event.reason;
  console.error("Unhandled Promise Rejection:", {
    type: "unhandledrejection",
    message: reason?.message || String(reason) || "Unhandled promise rejection",
    stack: reason?.stack || null,
  });

  window.location.href = "/embedded/jumpstart/error";
};

const router = createBrowserRouter([basicRoutes, proRoutes]);

createRoot(document.getElementById("migration-app-root") as HTMLElement).render(
  <RouterProvider router={router} />,
);
